/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
import * as Types from '../../../../queryTyping';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type VerifyRegistrationPassKeyMutationVariables = Types.Exact<{
  verifyRegistrationParams: Types.VerifyRegistrationParams;
}>;


export type VerifyRegistrationPassKeyMutation = (
  { __typename?: 'Mutation' }
  & { verifyRegistration: (
    { __typename?: 'VerifyRegistrationResult' }
    & Pick<Types.VerifyRegistrationResult, 'success' | 'message'>
  ) }
);


export const VerifyRegistrationPassKeyDocument = gql`
    mutation VerifyRegistrationPassKey($verifyRegistrationParams: VerifyRegistrationParams!) {
  verifyRegistration(verifyRegistrationParams: $verifyRegistrationParams) {
    success
    message
  }
}
    `;
export type VerifyRegistrationPassKeyMutationFn = Apollo.MutationFunction<VerifyRegistrationPassKeyMutation, VerifyRegistrationPassKeyMutationVariables>;

/**
 * __useVerifyRegistrationPassKeyMutation__
 *
 * To run a mutation, you first call `useVerifyRegistrationPassKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyRegistrationPassKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyRegistrationPassKeyMutation, { data, loading, error }] = useVerifyRegistrationPassKeyMutation({
 *   variables: {
 *      verifyRegistrationParams: // value for 'verifyRegistrationParams'
 *   },
 * });
 */
export function useVerifyRegistrationPassKeyMutation(baseOptions?: Apollo.MutationHookOptions<VerifyRegistrationPassKeyMutation, VerifyRegistrationPassKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyRegistrationPassKeyMutation, VerifyRegistrationPassKeyMutationVariables>(VerifyRegistrationPassKeyDocument, options);
      }
export type VerifyRegistrationPassKeyMutationHookResult = ReturnType<typeof useVerifyRegistrationPassKeyMutation>;
export type VerifyRegistrationPassKeyMutationResult = Apollo.MutationResult<VerifyRegistrationPassKeyMutation>;
export type VerifyRegistrationPassKeyMutationOptions = Apollo.BaseMutationOptions<VerifyRegistrationPassKeyMutation, VerifyRegistrationPassKeyMutationVariables>;